import { useEffect } from "react";
import { App } from "@capacitor/app";
import { Capacitor, type PluginListenerHandle } from "@capacitor/core";
import * as LiveUpdates from "@capacitor/live-updates";
import { AuthWrapper } from "pages";

export function LiveUpdate() {
  useEffect(() => {
    // exit early on web
    if (Capacitor.getPlatform() === "web") {
      return;
    }

    const handleLiveUpdates = async () => {
      let listener: PluginListenerHandle;

      // handle when app resumes
      const handleResumeUpdate = async () => {
        try {
          listener = await App.addListener("resume", async () => {
            const shouldReload = window.localStorage.getItem("shouldReloadApp") === "true";
            const isAuthenticating = window.localStorage.getItem("isAuthenticating") === "true";

            // don't reload if authentication is in progress (avoid user remaining logged out)
            if (shouldReload && !isAuthenticating) {
              await LiveUpdates.reload().catch((error) => {
                // eslint-disable-next-line no-console
                console.error("LiveUpdates.reload error:", error);
                // reset flag to prevent reload loop on failure
                window.localStorage.setItem("shouldReloadApp", "false");
              });
            } else {
              const result = await LiveUpdates.sync().catch((error) => {
                // eslint-disable-next-line no-console
                console.error("LiveUpdates.sync resume sync error:", error);
                return null;
              });

              // set LS flag if new version download was successful
              if (result) {
                window.localStorage.setItem(
                  "shouldReloadApp",
                  result.activeApplicationPathChanged.toString(),
                );
              }
            }
          });
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error("LiveUpdates unexpected handleResumeUpdate error:", error);
        }
      };

      handleResumeUpdate();

      try {
        // handle download of latest version upon app load
        const initialResult = await LiveUpdates.sync().catch((error) => {
          // eslint-disable-next-line no-console
          console.error("LiveUpdates.sync initial sync error:", error);
          return null;
        });

        // set LS flag if download was successful
        if (initialResult) {
          window.localStorage.setItem(
            "shouldReloadApp",
            initialResult.activeApplicationPathChanged.toString(),
          );
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("LiveUpdates unexpected error:", error);
      }

      return () => {
        listener?.remove();
      };
    };

    // initialize live updates
    handleLiveUpdates();
  }, []);

  return <AuthWrapper />;
}
